export default [
    {
        path: 'relatorio-inconsistencia',
        component: () => import(
            '@/views/atencao-basica/relatorio-inconsistencia/Index'
        ),
        redirect: 'relatorio-inconsistencia/index',
        children: [
            {
                name: 'atencao-basica-relatorio-inconsistencia',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/relatorio-inconsistencia/Form'
                ),
            },
        ],
    },
]